import { render, staticRenderFns } from "./FormAgendamento.vue?vue&type=template&id=eb724012"
import script from "./FormAgendamento.vue?vue&type=script&lang=js"
export * from "./FormAgendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports